import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { ButtonComponent, ButtonConfig } from '@waseel-asp/tpa-waseel-lib-staging';
import { getButtonConfig } from '../../functions/config-function';
import { NULL_VIEW_SYMBOL } from '../../constants/system-constants.model';

@Component({
  selector: 'app-copy-to-clipboard',
  standalone: true,
  imports: [ButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './copy-to-clipboard.component.html'
})
export class CopyToClipboardComponent implements OnInit, OnDestroy {
  private translation = inject(TranslateService);
  private cdr = inject(ChangeDetectorRef);

  @Input() value: string;
  @Input() resetDelay = 2000;
  @Input() copyToolTip = 'COMMON.COPY';
  @Input() copiedToolTip = 'COMMON.COPIED';
  @Input() isSmallSize = false;

  private destroy$ = new Subject<void>();
  isCopied = false;

  copyBtnConfig: ButtonConfig;

  ngOnInit(): void {
    const cssClass = ['copy-to-clipboard-btn'];
    if (this.isSmallSize) cssClass.push('btn-small-icon');
    this.copyBtnConfig = getButtonConfig(
      () => this.copyToClipboard(),
      'copy', 'icon', 'basic', null, null, () => this.isCopied, 'content_copy', null,
      this.translation.instant(this.copyToolTip), 'above', cssClass, null, 
      () => this.value && this.value != NULL_VIEW_SYMBOL
    );
  }

  copyToClipboard(): void {
    if (!this.value || this.value == NULL_VIEW_SYMBOL || this.isCopied) return;

    navigator.clipboard.writeText(this.value).then(() => {
      this.isCopied = true;
      this.copyBtnConfig.icon = 'done_all';
      this.copyBtnConfig.tooltipText = this.translation.instant(this.copiedToolTip);
      this.cdr.markForCheck();

      timer(this.resetDelay)
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          this.isCopied = false;
          this.copyBtnConfig.icon = 'content_copy';
          this.copyBtnConfig.tooltipText = this.translation.instant(this.copyToolTip);
          this.cdr.markForCheck();
        });
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
